import useSWR, { mutate } from "swr";

import { ApiClientFactory } from "common/middleware/api.client-factory";
import { Logger } from "common/middleware/logger";
import { callApi } from "common/middleware/api.helpers";

const getSharedOpportunity = async (
  key: string,
  opportunityId: string,
) => {
  Logger.debug("Getting opportunity", opportunityId);

  const client = await ApiClientFactory.getSharedOpportunitiesClient();

  const { data, error } = await callApi(client.get(opportunityId, undefined), {
    redirectTo404: true,
  });

  if (data) return data;

  throw error;
}

const SHARED_OPPORTUNITY_KEY = "/api/sharedOpportunity";

export const useSharedOpportunity = (
  opportunityId: string,
  opt?: {
    shouldFetch?: boolean,
  },
) => {
  const shouldFetch = opt?.shouldFetch !== false;

  const { data, error, mutate } = useSWR(
    shouldFetch && opportunityId
      ? [SHARED_OPPORTUNITY_KEY, opportunityId]
      : null,
    getSharedOpportunity
  );

  return {
    opportunity: data,
    isOpportunityLoading: Boolean(opportunityId) && shouldFetch && !data && !error,
    error,
    mutateOpportunity: mutate,
  }
}

export const mutateSharedOpportunity = async (opportunityId: string) => {
  await mutate([SHARED_OPPORTUNITY_KEY, opportunityId]);
}
